'use client';

import React from 'react';
import { cn } from '../../utils/cn';
import './Slider.css';

interface SliderProps {
  value: number;
  max: number;
  min?: number;
  step?: number;
  disabled?: boolean;
  onChange: (value: number) => void;
  onCommit?: (value: number) => void;
  className?: string;
  'aria-label'?: string;
  'data-testid'?: string;
}

export const Slider: React.FC<SliderProps> = ({
  value,
  max,
  min = 0,
  step = 1,
  disabled = false,
  onChange,
  onCommit,
  className,
  ...rest
}) => {
  const span = Math.max(1, max - min);
  const filled = Math.min(100, Math.max(0, ((value - min) / span) * 100));

  return (
    <input
      type="range"
      className={cn('shot-slider', className)}
      style={
        {
          '--shot-slider-filled': `${filled}%`,
          '--shot-slider-fill-alpha': filled > 0 ? 1 : 0,
        }
      }
      min={min}
      max={max}
      step={step}
      value={Math.min(max, Math.max(min, value))}
      disabled={disabled}
      onChange={(event) => onChange(Number(event.target.value))}
      onPointerUp={(event) => onCommit?.(Number(event.currentTarget.value))}
      onTouchEnd={(event) => onCommit?.(Number(event.currentTarget.value))}
      onKeyUp={(event) => onCommit?.(Number(event.currentTarget.value))}
      onBlur={(event) => onCommit?.(Number(event.currentTarget.value))}
      {...rest}
    />
  );
};
